import { createEndpointConfig } from '@ricoh/ria.client.core/plugins/swr/common';

import type { EditUserProfileRequestData } from './_request.type';

import createRequestConfig from '../_config';

/** Internal request config. */
const requestConfig = createRequestConfig('profile', (keyBase) => ({
  getUserProfile: createEndpointConfig(`[get] ${keyBase}/profile`, () => ({
    method: 'get',
    url: 'profile',
  })),

  editUserProfile: createEndpointConfig(`[put] ${keyBase}/profile`, (requestData: EditUserProfileRequestData) => ({
    method: 'put',
    url: `profile`,
    data: requestData,
  })),
  editUserAvatar: createEndpointConfig(`[post] ${keyBase}/profile/avatar`, (avatar: File) => {
    const formData = new FormData();
    formData.append('avatar', avatar);

    return {
      method: 'post',
      url: `profile/avatar`,
      data: formData,
    };
  }),
}));

export default requestConfig;
